import { Space, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { DownloadOutlined, PrinterOutlined } from "@ant-design/icons";
import { ModalItem, ButtonItem } from "../../../../Components/Items";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import etiquetasMovimientoInventarioPdf from "../../../../Pdf/etiquetasMovimientoInventarioPdf";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

class ModalEtiquetasMovimientoInventario extends Component {
  state = {
    loading: false,
    datos: null,
    conDatosEmpresa: true,
    pdf: null,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible) {
      this.setState({ conDatosEmpresa: true, datos: null }, () =>
        this.consultarDatos()
      );
    }
  }

  consultarDatos() {
    this.setState({ loading: true });
    axios
      .post(
        "movimientosInventario/datosPdfMovimientoInventario",
        {
          movimientoId: this.props.movimientoId,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({ datos: res.data, loading: false }, () =>
            this.generarPdf(this.state.conDatosEmpresa)
          );
        } else {
          message.error("No se encontraron datos del movimiento");
          this.setState({ loading: false });
        }
      })
      .catch(() => {
        message.error("Error al generar el documento");
        this.setState({ loading: false });
      });
  }

  generarPdf(conDatosEmpresa) {
    if (!this.state.datos) return;
    etiquetasMovimientoInventarioPdf(this.state.datos, {
      conDatosEmpresa,
    }).then((dd) => {
      const pdf = pdfMake.createPdf(dd);
      this.setState({ pdf }, () => {
        pdf.open({}, window.frames["EtiquetasMovimientoInventarioIframe"]);
      });
    });
  }

  cambiarOpcion(conDatosEmpresa) {
    if (conDatosEmpresa === this.state.conDatosEmpresa) return;
    this.setState({ conDatosEmpresa }, () => this.generarPdf(conDatosEmpresa));
  }

  descargarPdf() {
    if (this.state.pdf) {
      const folio = this.props.movimientoFolio || "Documento";
      this.state.pdf.download(`Etiquetas_${folio}.pdf`);
    }
  }

  handleCancel = () => {
    this.props.onCancel();
  };

  render() {
    const { conDatosEmpresa } = this.state;
    return (
      <ModalItem
        title="Etiquetas de Insumos"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.handleCancel}
        paddingTop
        width={900}
        footer={null}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 8,
            marginBottom: 10,
          }}
        >
          <Space>
            <ButtonItem
              type={conDatosEmpresa ? "primary" : "default"}
              cyan={conDatosEmpresa}
              blanco={!conDatosEmpresa}
              icon={<PrinterOutlined />}
              onClick={() => this.cambiarOpcion(true)}
            >
              Con datos de empresa
            </ButtonItem>
            <ButtonItem
              type={!conDatosEmpresa ? "primary" : "default"}
              cyan={!conDatosEmpresa}
              blanco={conDatosEmpresa}
              icon={<PrinterOutlined />}
              onClick={() => this.cambiarOpcion(false)}
            >
              Sin datos de empresa
            </ButtonItem>
          </Space>
          <Space>
            <ButtonItem
              icon={<DownloadOutlined />}
              type="primary"
              onClick={() => this.descargarPdf()}
            >
              Descargar PDF
            </ButtonItem>
            <ButtonItem danger onClick={this.handleCancel}>
              Cerrar
            </ButtonItem>
          </Space>
        </div>

        <iframe
          title="Etiquetas Movimiento Inventario"
          style={{ width: "100%", height: "75vh", border: "1px solid #d9d9d9" }}
          id="EtiquetasMovimientoInventarioIframe"
          name="EtiquetasMovimientoInventarioIframe"
        />
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalEtiquetasMovimientoInventario);
